import { HasClassName } from '~/types/HasClassName';
import { FC, PropsWithChildren } from 'react';
import styles from './MenuInline.module.css';
import { NavLink } from 'react-router';
import classNames from 'classnames';

interface ItemProps {
  icon: FC<HasClassName>;
  label: string;
  to: string;
}

function MenuInlineElement({ children }: PropsWithChildren) {
  return <nav className={styles.menuInline}>{children}</nav>;
}

function Item({ to, label, icon: Icon }: ItemProps) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        classNames(styles.item, {
          [styles.active]: isActive,
        })
      }
    >
      <Icon />
      {label}
    </NavLink>
  );
}

export const MenuInline = Object.assign(MenuInlineElement, {
  Item,
});
